<template>
  <div class="wrap project-item" :class="{ 'view-table-row': view === 'table-row' }" >
    <a :href="`https://giraffesoftware.atlassian.net/browse/${link}`" target="_blank" class="project-link"
    v-b-tooltip.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="getProjectTooltip || ''">
      <div class="project-title">
        <span v-show="!hideNumber" v-if="number || number === 0">{{ number + 1 }}.</span> {{ projectName }}
      </div>
      <div class="project-subtitle" v-if="projectSubtitle !== ''">
        {{ projectSubtitle }}
      </div>
      <div class="project-owner">
        {{ projectClients }}
      </div>
    </a>
  </div>
</template>

<script>

export default {
  name: 'TableProjectItem',
  props: {
    link: {
      type: String,
      default: ''
    },
    number: {
      type: Number,
      default: 1
    },
    projectName: {
      type: String,
      default: ''
    },
    projectSubtitle: {
      type: String,
      default: ''
    },
    projectClients: {
      type: String,
      default: ''
    },
    view: {
      type: String,
      default: 'default'
    },
    hideNumber: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getProjectTooltip () {
      return `<div class="text-left">${this.projectName || ''} <br/> ${this.projectSubtitle || ''}</div>` || ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .wrap.project-item {
    background-color: transparent;
  }

  .wrap.project-item .project-link {
  max-width: -webkit-fill-available;
}

  .project {
    &-item {
      padding: 8px !important;
    }
    &-link {
      &:hover {
        text-decoration: none;
      }
    }
    &-title {
      font-size: 13px;
      color: #3D5170;
      max-width: 150px;
      margin-bottom: 2px;
      line-height: 24px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    &-subtitle {
      font-size: 11px;
      color: #7489A9;
      max-width: 350px;
      margin-bottom: 2px;
      line-height: 16px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    &-owner {
      font-size: 11px;
      color: #7489A9;
      max-width: 150px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .view-table-row {
    display: flex;
    align-items: center;
    .project-owner {
      display:none;
    }
  }
</style>
